const SubCategory = [
  { id: 1, name: "Story" },
  { id: 2, name: "Graphic Novel" },
  { id: 3, name: "Poetry" },
  { id: 4, name: "Diary" },
  { id: 5, name: "Opinion Piece" }
];

export { SubCategory };
